var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThailan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 341.326,
    y: 85.334,
    fill: "#f0f0f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 123.882,
    y: 194.056,
    fill: "#0052b4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 54.522,
    y: 85.334,
    fill: "#d80027"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 54.522,
    y: 372.143,
    fill: "#d80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThailan);
export default __webpack_public_path__ + "static/media/thailan.6efb37b68401a5f38fc760ae27684bd6.svg";
export { ForwardRef as ReactComponent };